export default __webpack_public_path__ + "static/media/bg_outline2.3e1994dc.png";